import BOOKING from "./types";
import { promiseAction } from "~/misc/dispatch";
import {
  cancelBooking,
  creatBooking,
  getMyBookings,
  deletBooking,
  uploadFile,
  getNeedVerificationAPI,
  saveUploadFileAPI,
  createBookDynamic as createBookDynamicAPI
} from "~/api/booking";

export const deleteBookingAction =
  ({ bookingId, loadId }) =>
  (dispatch, getState) =>
    promiseAction(
      dispatch,
      getState,
      BOOKING.BOOKING_DELETE,
      deletBooking(getState, { bookingId, loadId })
    );

export const cancelBookingAction =
  ({ bookingId, rejectReason, loadId }) =>
  (dispatch, getState) =>
    promiseAction(
      dispatch,
      getState,
      BOOKING.BOOKING_CANCEL,
      cancelBooking(getState, { bookingId, rejectReason, loadId })
    );

export const createBookingAction = (postData) => (dispatch, getState) =>
  promiseAction(
    dispatch,
    getState,
    BOOKING.BOOKING_CREATE,
    creatBooking(getState, postData)
  );

export const createBookDynamic = (shipmentId, nextNode) =>  (dispatch, getState) =>
  promiseAction(
    dispatch,
    getState,
    BOOKING.BOOKING_CREATE_DYNAMIC,
    createBookDynamicAPI(getState, shipmentId, nextNode)
  );

export const getMyBookingsAction = () => (dispatch, getState) =>
  promiseAction(
    dispatch,
    getState,
    BOOKING.BOOKING_GET,
    getMyBookings(getState)
  );

export const uploadFileAction = (file) => (dispatch, getState) =>
  uploadFile(getState, file);

export const verifyLoads = (postData) => (dispatch, getState) =>
  getNeedVerificationAPI(getState, postData);

export const saveUploadFileAction = (saveData) => (dispatch, getState) =>
  saveUploadFileAPI(getState, saveData);



// WEBPACK FOOTER //
// ./src/modules/bookings/action.js